import { OPEN_DIALOG, CLOSE_DIALOG } from "./../actions/dialogActions";
const dialogReducer = (state = false, action) => {
  console.log("dialogReducer", state);
  if (action.type === CLOSE_DIALOG) {
    return false;
  } else if (action.type === OPEN_DIALOG) {
    return true;
  }
  return state;
};
export default dialogReducer;
